import { CounselingTypeEnum } from 'app/Bookings/constants'
import CounselingTypeCardContent from '../CounselingTypeCardContent'

type CounselingGridDropdownProps = {
  options: SelectItem[]
  onSelectItem: (option: SelectItem) => void
  selectedValue?: string
}

const CounselingGridDropdown: React.FC<CounselingGridDropdownProps> = ({
  options,
  onSelectItem,
  selectedValue,
}) => {
  const isOneOption = options.length === 1
  const isThreeOptions = options.length === 3

  return (
    <div
      className={`~absolute ~z-10 ~mt-1 ~bg-light-grey ~rounded-lg ~shadow-[0px_2px_18px_rgba(0,0,0,0.18)] ~p-2 ${
        isOneOption ? '~w-[222px]' : '~min-w-[468px]'
      }`}
    >
      <div
        className={`~grid ~gap-2 ${
          isOneOption ? '~grid-cols-1' : '~grid-cols-2'
        }`}
      >
        {options.map((option, index) => {
          const isFullWidth = isThreeOptions && index === 0
          const isSelected = option.label === selectedValue

          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={isSelected}
              onClick={() => onSelectItem(option)}
              className={`~p-4 ~w-full ~self-stretch ~rounded ~bg-white ~cursor-pointer ~border-2 ~border-solid ~border-transparent hover:~border-sunrise-60 ${
                isFullWidth ? '~col-span-2' : ''
              }`}
            >
              <CounselingTypeCardContent
                counselingType={option.label as CounselingTypeEnum}
                fallbackLabel={option.label}
                variant="desktop"
              />
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default CounselingGridDropdown
